import * as React from "react";
import { Link } from "gatsby";

import Layout from "../../components/Layout";
import Seo from "../../components/Seo";

import Old2005BlogPage from "../../components/Old2005BlogPage";

const OldBlogPage = () => (
  <Layout>
    <Seo title="Old 2005 Blog—May 2005" />
	<Old2005BlogPage>
		<h2>May 2005</h2>





		<h3 className="blogdate">
		Monday, May 30, 2005
		</h3>






		<h4 className="blogitemtitle">
		Good thing I used to practice "no-clutch" driving
		</h4>





			<div className="blogitembody">
			The clutch lever stopped working in the van about 30 km outside of Margaret River; I noticed it at a T-intersection while stopping.  I don't know much about Nissan vans; I tried to troubleshoot it but couldn't figure it out.  So we pushed the van in motion, slipped it into first gear and I drove it, shifting up and down without a clutch (and doing so quite well), to Margaret River's garage.  We camped overnight in the parking lot!  Sweeet!  Should be fixed today for about $100.<br /><br />Going to spend a couple days here before moving north.  The highlights of the recent days have been Cape Le Grande National Park, which includes Frenchman's Peak and Lucky Bay.  You must see these places.  The Southern Forests are amazing but we ripped through them too quickly.  I have learned of something for next time...  the Bibbulmun Track is almost 1000km of hiking/biking through the coastline and amazing forests, stopping at towns for showers/backpacker hostels, and camping along the way.  I wanted to climb the 60 m Gloucester Tree but we didn't have time.  We did the Tree Top Walk, 40 m above ground in the Karri and Tingle trees - kinda cool but a bit hokey.  The trees are most impressive from the ground as you drive, walk, or just rest among them.  Albany has some cool sights, including the Bridge and Gap on the way to Frenchman Bay (who the hell was this Frenchman?), and the Wind Farm.  75% of the city's power is generated by wind energy!  The turbines are huge and beautiful on the green hill above a roaring ocean coastline.  Also, a little town called Denmark was quite notable -  a laid-back artsy-craftsy town that I could imagine myself spending some time in.<br /><br />Okay, well I think I will skip out on the wine tours here in Margaret River, and instead spend some time at the beach, maybe even rent a surfboard again and see if I can survive "The Box".  Unfortunately the beach is 12 km away, and the van is under repair.  Now where can I rent a bike?
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 2:06 PM &nbsp;

			</div>






		<h3 className="blogdate">
		Tuesday, May 24, 2005
		</h3>






		<h4 className="blogitemtitle">
		I like my kangaroo medium-rare!
		</h4>





			<div className="blogitembody">
			Yes, that's right! After seeing over 200 kangaroo in the past few days, I decided to eat some! It's delicious and lean, like venison but less wild tasting. You should try it! Unfortunately, three quarters of the roos I've seen in the past few days have been roadkill. The A1 highway through the Nullarbor is an open buffet for carrion birds. I got my portion from the supermarket and we cooked it on a little portable barbeque.<br /><br />The Nullarbor trip was very very cool and I am so glad I left the city. I think I am just enjoying moving along and seeing new things! I still have some money so that is what I am doing still... I have been in a limestone cave, Cocklebiddy Cave, where you can swim in complete darkness. I have seen one of the first earliest telegraph stations in ruin along the ocean. I have seen Southern Right Whales playing at Head of Bight. I have had campfires in "the bush"! The campervan is a pig on gas but it is doing good for us.  I have been driving 4-on-the-tree and on the wrong side of the road!<br /><br />Today I think I will climb to the top of Frenchman's Peak in Cape Le Grande, which is outside of a town called Esperance. From there, I don't know! Until next time...
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 1:56 PM &nbsp;

			</div>






		<h3 className="blogdate">
		Wednesday, May 18, 2005
		</h3>






		<h4 className="blogitemtitle">
		You gotta love the Irish
		</h4>





			<div className="blogitembody">
			I was feeling down yesterday until I met Jon and arranged to drive west accross the Nullabor.  That really cheered me up!  Then, back at the hostel (called "My Place" in Adelaide), I broke out the guitar and played literally for 3 to 4 hours without repeating a song (I doodled here and there, though)!  We all sat out on the balcony and I just played.  It was great!  It's often difficult to find a good spot to practice when you are hostelling... so you just gotta perform (even though it is really practicing) in front of whoever is in-the-way.  Anyways, met lots of people while and after playing!<br /><br />My dorm was full of Irish blokes and gals so guess what happened last night?  Yes, you guessed it, we had lots of fun!  That's the drunkest I've been since coming here!  I love the Irish.  When you are travelling and you want to be social... look for Irish folks!  We all fell asleep listening to John Butler and woke up and had breakie, too!  The funny thing about travelling is how quickly every one becomes friends and how quickly everyone goes seperate ways.  It's all about "traveller" friendships.  Naturally I miss my long term friendships, and I sure miss Crazy French Girl :)<br /><br />Many pubs in Australia are REAL Public Houses, with fireplaces and usually different rooms, like a common/living room, the bar room, and usually bedrooms upstairs for travellers of the old days.  I love it!  The buildings are very old here which is super cool.<br /><br />Also, the weather sucks in Melbourne and rocks in Adelaide.  I am not really in a position to make such a generalization, but I have spoken and it is true.  It is almost winter here and I might sunburn this morning if I am not careful.  So today I am going to buy some sunblock and a sleeping bag for new adventure which starts tomorrow morning!!!<br /><br />By the way, Erin and Rebecca:  I have kept my beard just for you and I look... not bad!  I can't grow on my right cheek, center, though.  But who fucking cares?  Not me.  You know what feels good?  <em>Salt water dripping from your bearded face as you pull yourself from the last wave that kicked your ass off your surfboard.  </em>I am living.
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 12:44 PM &nbsp;

			</div>






		<h3 className="blogdate">
		Tuesday, May 17, 2005
		</h3>






		<h4 className="blogitemtitle">
		Go West!!!
		</h4>





			<div className="blogitembody">
			I haven't been in Adelaide for a day and I have already met Jon from London... we are leaving Thursday morning to drive in a camper van accross the Nullabor (spelling?)!  We are going to see places in the southwest corner of Oz, like Margaret River, and Cape Naturaliste, and whatever we choose.  We tentatively are parting ways in Perth where he will continue on to Broome, and I may want to visit Sydney.<br /><br />In Sydney, there is Andrew who I'd like to visit, plus I have made a new good friend named Rik who is a poet and peforming artist (acting, comedy).  We have great conversations about life and values and he influences me to try and succeed as a singer/songwriter/guitarist.  I know I shouldn't need a push, but it's wierd, I just<em> do</em> need a push here and there.  But first... I am going west!!!  With my guitar of course!<br /><br />So... until I next find time and cheap internet.... Take care!!!  By the way, if you are reading this and you know me... then consider yourself missed as I do miss you.  If you don't know me (personally) then don't be silly, how could I be missing you?
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 6:06 PM &nbsp;

			</div>






		<h3 className="blogdate">
		Sunday, May 15, 2005
		</h3>






		<h4 className="blogitemtitle">
		Surfing in Torquay, Victoria!
		</h4>





			<div className="blogitembody">
			Here I am at Bell's Beach Backpacker Lodge, laying back and surfing!  This is home of the head offices and designing of RipCurl, as well as Quicksilver, and home of Xavier Rudd (or atleast where he grew up)!  The water is 17 degrees and salty, but once your in (with a wetsuit) it's okay.  The weather was warm yesterday but a little bit chilly autumnish today.  I will see the rest of the Great Ocean Road tomorrow and then catch a night bus to Adelaide.  From Adelaide I will look for a ride to "wherever".  Being out of the cities is great and I've considered spending a whole week here in the small towns of the Surf Coast!  But, moving on will be good because I get to see more!<br /><br />By the way, surfing is addictive.  I'd like to buy a Toyota HiAce van and a surf board and roam the country!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 3:27 PM &nbsp;

			</div>






		<h3 className="blogdate">
		Wednesday, May 11, 2005
		</h3>






		<h4 className="blogitemtitle">
		Time to leave Melbourne
		</h4>





			<div className="blogitembody">
			Yes, this place is rad... but it is expensive and I don't want to work yet.  I'd rather spend my money travelling than living in Melbourne!  So next is the Great Ocean Road, with surfing stops at the famous Bell's Beach in Torquay, plus maybe Lorne!  It should be decent, yet a bit chilly.<br /><br />After that I think I will visit Sydney and possibly a little place called Mooloolaba in Queensland (warm and rainforesty), where I might be able to be a surf bum for a bit.  I'm going to meet with my cousin tonight and discuss getting there and staying and surfing, etc.  After that, I'm not sure... but the west coast is calling me...
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 3:19 PM &nbsp;

			</div>






		<h3 className="blogdate">
		Sunday, May 08, 2005
		</h3>






		<h4 className="blogitemtitle">
		Ship and Anchor songwriting contest
		</h4>





			<div className="blogitembody">
			So it is about 7:00 pm in Calgary now on Saturday, which means the Ship and Anchor songwriting contest should be completed for the day!  Rebecca, I hope you had a fun, good time with it!  Thanks again and again!  If anyone wants to post comments about it here, they can!  I'm going camping for a few days now...
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 1:03 PM &nbsp;

			</div>






		<h3 className="blogdate">
		Saturday, May 07, 2005
		</h3>






		<h4 className="blogitemtitle">
		LabJacd at The Nightcat, Fitzroy, May 6 2005
		</h4>





			<div className="blogitembody">
			I only caught the last few songs of the show, but I was so <em>very</em> impressed.  3 piece brass (trumpet, trombone, sax), 2 or 3 percussion, latin/spanish uke, hand shakers, a spinner, a stand-up bass, guitar, latin/spanish hip-hop lyrics, and overall FUNKY and TIGHT.  The encore song was so cool - the brass dudes toured around the club during a breakdown in the song and the sound of their instruments was incredible as they mingled through the crowd.  It was so much fun!  It was high energy to and from the crowd.  And a great venue!  You should see these guys.  Fun, fun, fun!<br /><br />Links:<br /><a href="http://www.labjacd.com/">http://www.labjacd.com/</a>
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 12:54 PM &nbsp;

			</div>











		<h4 className="blogitemtitle">
		If I ever move to Melbourne...
		</h4>





			<div className="blogitembody">
			... it will be for the Queen Victoria Market north of the Central Business District.  Also for the band LabJacd that played at the NightCat last night in Fitzroy.  Both moved me...  Wow!  I bought an Indiana Jones hat and am the only fool in the city wearing one, so I stand out nicely!  Nobody cares here, especially me!  Jon (from New York) and I made a tasty pasta last night with fresh produce from the Vic Market.  Last night was a social night at The Nunnery (my hostel) and I played "Crazy French Girl" and "Deadbeat Blues" and Blue Rodeo's "Hasn't Hit Me Yet"... made some friends.  May be leaving Melbourne for a little tour soon with a comedy performer named Rick (from Sydney)...  But will be back.  Either that or will drive the Great Ocean Road with Tom, stay in Adelaide and then come back.  I think I will visit Sydney in the next couple months.  I dunno.  I am making it up as I go!<br /><br />It is EXPENSIVE here.  I don't have as much time as I thought (without working, busking, gigging, etc).  So I am always thinking about how and when I will make some money.  There many options to learn about from other travellers!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 12:18 PM &nbsp;

			</div>






		<h3 className="blogdate">
		Thursday, May 05, 2005
		</h3>






		<h4 className="blogitemtitle">
		Sight Seeing is Fun!
		</h4>





			<div className="blogitembody">
			But Holy Shit my arm is getting tired from carrying my guitar around! I have walked and explored some of downtown Melbourne, also Fitzroy and Carlton, and today St. Kilda. Fitzroy is happening with a million licensed cafe/restaurants with sidewalk patios, and music venues galore. Carlton is Italian Restaurant central. I am taking the occasional photo to remember some of it. It is raining today which made St. Kilda a little less than expected; it is a beach area and full of cool shops and licensed cafes again. Melbourne is the city of licensed cafes.  And ultra cool Victorian buildings.<br /><br />I am intimidated by Fitzroy (Brunswick St, Smith St); I want to try and get a live show as "that Canadian dude" but I don't know where to start. I guess in time, I've only been here a few days. My hostel is quite expensive and I might move soon. I haven't figured out what to do next yet, but Melbourne is still under exploration by Jesse the... explorer. I made a new friend from France when I was playing in the street last night on Brunswick St, and today we explored St. Kilda. Truthfully I prefer exploring alone, but it was nice to have some company. Tonight I might check out the live music at the Espy in St. Kilda. You take a street Tram to get there, very cool!<br /><br />Okay, that's it for now!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 6:10 PM &nbsp;

			</div>






		<h3 className="blogdate">
		Tuesday, May 03, 2005
		</h3>






		<h4 className="blogitemtitle">
		First Day in Melbourne
		</h4>





			<div className="blogitembody">
			Well, I'm here!  Jet lag is minimal as I was coordinating sleep with Melbourne time on the plane rides.  Malaysian Airlines is not too shabby, and neither is their food.  Malaysia is hot and humid.  I had a beer outside in a ghost town (it was a holiday) called Nilai while waiting for my flight.  The Kuala Lumpur airport is super modern cool!  I met a dude named Kyl at the Melb airport and he showed me around a bit.  Then I walked in typical Jesse fashion from the south end of downtown to Fitzroy and secured a room at the Nunnery (hostel).  I am in an internet cafe right now on Brunswick Rd which is supposed to be really cool.<br /><br />Travelling is very different and new to me; I have LOTS to learn.  Initially it is scary, yet exciting.  I will write more soon!
			</div>
			<div className="blogitemfooter">
			posted by Jesse @ 5:50 PM &nbsp;

			</div>







		<p>
			<Link to="/blog2005/">Go back to the blog index page</Link>
		</p>
</Old2005BlogPage>
  </Layout>
)

export default OldBlogPage;
